<template>
  <div class="box order-card-page order-detail-page">
    <div class="content-container">
      <div class="order-card-wrap">
        <div class="bgc order-surface-card order-surface-card--tag">
          <div class="order-card-status-head">
            <div class="order-status-tag" :class="getStatusClass()">{{ getStatus() }}</div>
          </div>
          <!-- 影院信息 - 与影院列表样式一致 -->
          <div class="info-block cinema-info-block">
            <div class="cinema-name-main">{{ movieData?.cinemaName }}</div>
            <div class="cinema-addr-row">
              <van-icon name="location-o" size="0.9rem" color="#999" />
              <span>{{ movieData?.cinemaAddress || '暂无地址' }}</span>
            </div>
          </div>
          <!-- 影片信息 -->
          <div class="info-block">
            <div class="movie-info-row">
              <img :src="movieData?.moviePicUrl" alt="" class="movie-poster" />
              <div class="movie-details">
                <div class="movie-name">{{ movieData?.movieName }}</div>
                <div class="movie-time-row">
                  <span class="play-time">{{ movieData?.moviePlayTime }}</span>
                  <span class="hall-type-tag" v-if="movieData?.hallType">{{ movieData?.hallType }}</span>
                </div>
                <div class="hall-name">{{ movieData?.hallName }}</div>
                <!-- 座位信息 -->
                <div class="seat-info-inline">
                  <van-icon name="coupon-o" size="0.85rem" color="#ee0a24" />
                  <span class="seat-value">{{ movieData?.seatNames }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 票码信息 -->
          <div v-if="this.Paystatus == '7' && movieData?.ticketList" class="info-block ticket-swipe-wrapper">
            <div class="ticket-title-row">
              <span class="ticket-title">取电影票</span>
              <span class="ticket-count-badge">{{ movieData?.number }}张票</span>
            </div>
            
            <van-swipe class="ticket-swipe" :loop="false" indicator-color="#1890FF">
              <van-swipe-item v-for="(ticket, tIndex) in movieData.ticketList" :key="tIndex">
                <div class="ticket-slide-content">
                  <div class="qr-section">
                    <van-image class="qr-image image-guard-skip" lazy-load :src="ticket.qrCode"></van-image>
                  </div>
                  <div class="code-section">
                    <div v-for="(codeItem, cIndex) in ticket.code" :key="cIndex" class="code-row">
                      <span class="code-label">{{ codeItem.text }}:</span>
                      <span class="code-value">{{ codeItem.value }}</span>
                    </div>
                  </div>
                  <div v-if="ticket.machineInfo" class="machine-info">
                    <van-icon name="info-o" size="0.8rem" />
                    <span>{{ ticket.machineInfo }}</span>
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
      </div>

      <!-- 待出票提示 -->
      <div v-if="this.Paystatus == '6'" class="bgc order-surface-card ticket-pending">
        <van-image class="tickets" :src="ticketsback"></van-image>
        <div class="pending-title">正在出票...</div>
        <div class="pending-desc">预计1-30分钟内出票，若遇到影院异常导致出票失败，系统将为您自动退款</div>
        <div class="refresh-section">
          <div class="refresh-tip">如长时间未出票，可手动刷新订单状态</div>
          <div class="refresh-btn-wrapper">
            <button class="refresh-btn-large" :class="{ disabled: isRefreshing || isCooldown }" @click.stop="onRefreshClick">
              {{ isRefreshing ? '刷新中...' : (isCooldown ? cooldownText : '点击刷新') }}
            </button>
          </div>
        </div>
      </div>

      <!-- 订单信息块 -->
      <div class="bgc order-surface-card order-meta-card" style="margin-bottom: 3rem;">
        <div style="font-size: 1rem;font-weight: 600; margin: 0.5rem;">订单信息</div>
        <div style="display: flex;  justify-content: space-between;font-size: 0.9rem;">
          <span style=" margin: 0.5rem; color: #888;">订单编号</span>
          <div class="order-number-section">
            <span>{{ orderNo }}</span>
            <span class="copy-btn" @click="copyText(orderNo)">复制</span>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: space-between;font-size: 0.9rem; ">
          <span style="margin: 0.5rem; color: #888;">下单时间</span>
          <span style=" margin: 0.5rem; ">{{ add_time }}</span>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: space-between; font-size: 0.9rem;">
          <span style=" margin: 0.5rem; color: #888;">手机号</span>
          <span style=" margin: 0.5rem; ">{{ getPhone() }}</span>
        </div>
        <div v-if="movieDetail?.consumptionType" @click="showPayDetail" class="expandable-row">
          <span class="row-label">支付方式</span>
          <div class="expand-indicator">
            <span class="row-value">{{ getPayType() }}</span>
            <span class="expand-text">查看</span>
            <van-icon name="arrow" size="0.8rem" color="#1890FF" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="Paystatus == '0'" class="bottom">
      <div class="price">
        <span style="font-size: 0.85rem;margin-top: 0.1rem;font-weight: 500;color: #D23B2E;">需支付：{{ Point }}{{ movieDetail?.cardPointTypeUnit || '点' }}</span>
      </div>
      <div class="flex">
        <div class="action-btn action-btn-secondary" @click.stop="showDialog">
          取消订单
        </div>
        <div class="action-btn action-btn-primary" @click.stop="changePay">
          去支付
        </div>
      </div>
    </div>
    <PayList v-if="showPL" :pay-list="payList" @closed="closedPay">
    </PayList>
  </div>
</template>

<script>
import PayList from "../../components/order/PayList.vue";
import { isUnifiedOrderPaid, startUnifiedPayStatusPoll } from "@/utils/orderPayPoll";

export default {
  name: "",

  data() {
    return {
      ticketsback: require("@/assets/images/issue_tickets.png"),
      add_time: "",
      form: {
        orderId: '',
        qmmOrderId: '',
      },
      phone: '',
      movieData: null,
      movieDetail: null,
      Paystatus: '',
      userId: '',
      weiPrice: null,
      orderNo: '',
      Point: null,
      showPL: false,
      payList: [],
      // 刷新与节流控制
      isRefreshing: false,
      isCooldown: false,
      cooldownDuration: 8, // 刷新冷却秒数
      cooldownRemain: 0,
      cooldownTimer: null,
      browserBackGuardEnabled: false,
      stopPayConfirmPoll: null,
    };
  },
  components: { PayList },
  methods: {
    enableBrowserBackGuard() {
      if (this.browserBackGuardEnabled) return;
      // 追加一层当前详情页历史，拦截微信浏览器底部返回时回到收银台的问题。
      window.history.pushState({ fromUnifiedCashierGuard: true }, '', window.location.href);
      window.addEventListener('popstate', this.handleBrowserBackGuard);
      this.browserBackGuardEnabled = true;
    },
    handleBrowserBackGuard() {
      // 仅对“支付成功后从统一收银台进入详情”的场景生效，统一改回订单列表。
      this.$router.replace({ path: '/AllOrder', query: { active: 1 } });
    },
    disableBrowserBackGuard() {
      if (!this.browserBackGuardEnabled) return;
      window.removeEventListener('popstate', this.handleBrowserBackGuard);
      this.browserBackGuardEnabled = false;
    },
    showPayDetail() {
      if (this.payList && this.payList.length > 0) {
        this.showPL = true
      }
    },
    closedPay(val) {
      this.showPL = val
    },
    getPayType() {
      if (this.movieDetail?.consumptionType == '0') {
        return '卡余额支付'
      } else if (this.movieDetail?.consumptionType == '1') {
        return '在线支付'
      } else if (this.movieDetail?.consumptionType == '2') {
        return '卡余额支付+微信支付'
      }
    },
    toPay() {
      // 统一跳转到统一支付页面，只需传订单号
      this.$router.push({
        path: "/UnifiedCashier",
        query: {
          orderNo: this.orderNo,
        },
      });
    },
    showDialog() {
      this.$Dialog.confirm({
        title: "提示",
        message: "是否确认取消订单？",
        confirmButtonText: '我在想想',
        cancelButtonText: '取消订单'
      })
        .then(() => {
        })
        .catch(() => {
          // on cancel
          this.cancelPayment()
        });
    },
    cancelPayment() {
      this.$api
        .cancelPayment(this.form.qmmOrderId)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg);
          } else {
            this.$Toast(res.msg);
            this.$router.back();
          }

        })
        .catch((err) => {
          this.$Toast(err.msg);
        });
    },

    changePay() {
      this.toPay()
    },
    queryMovieTicketDetail() {
      return this.$api
        .queryMovieTicketDetail(this.orderNo)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.code);
          } else if (res.data) {
            this.movieDetail = res.data;
            this.form.orderId = res.data.orderId;
            this.form.qmmOrderId = res.data.qmmOrderId;
            this.payList = this.movieDetail.spendLogList;
            this.movieData = JSON.parse(res.data.orderDetail);
            this.add_time = res.data.createTime;
            this.Point = this.movieDetail.originalPrice;
            this.movieDetail.productSubOrderList.forEach((element) => {
              this.Paystatus = element.status;
            });
          }
          return this.Paystatus;
        })
        .catch(() => {
          return this.Paystatus;
        });
    },
    stopUnifiedCashierPayPoll() {
      if (typeof this.stopPayConfirmPoll === "function") {
        this.stopPayConfirmPoll();
        this.stopPayConfirmPoll = null;
      }
    },
    startUnifiedCashierPayPollIfNeeded() {
      if (this.$route.query.fromUnifiedCashier !== "1") {
        return;
      }
      if (isUnifiedOrderPaid(this.Paystatus)) {
        return;
      }
      this.stopUnifiedCashierPayPoll();
      this.stopPayConfirmPoll = startUnifiedPayStatusPoll({
        fetchStatus: () => this.queryMovieTicketDetail(),
      });
    },
    onRefreshClick() {
      if (this.isRefreshing || this.isCooldown) {
        return
      }
      this.refresh()
      this.startCooldown()
    },
    refresh() {
      this.$Toast('正在刷新...')
      this.isRefreshing = true
      this.queryMovieTicketDetail()
        .finally(() => {
          this.isRefreshing = false
        })
    },
    startCooldown() {
      this.isCooldown = true
      this.cooldownRemain = this.cooldownDuration
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer)
        this.cooldownTimer = null
      }
      this.cooldownTimer = setInterval(() => {
        if (this.cooldownRemain > 0) {
          this.cooldownRemain--
        }
        if (this.cooldownRemain <= 0) {
          this.isCooldown = false
          clearInterval(this.cooldownTimer)
          this.cooldownTimer = null
        }
      }, 1000)
    },

    getPhone() {
      return this.$utils.formPhone(this.phone);
    },
    getStatus() {
      if (this.Paystatus == '0') {
        return '待支付'
      } else if (this.Paystatus == '1') {
        return '待发货'
      } else if (this.Paystatus == '2') {
        return '已发货'
      } else if (this.Paystatus == '3') {
        return '已完成'
      } else if (this.Paystatus == '4') {
        return '已取消'
      } else if (this.Paystatus == '5') {
        return '已超时'
      } else if (this.Paystatus == '6') {
        return '出票中'
      } else if (this.Paystatus == '7') {
        return '出票成功'
      } else if (this.Paystatus == '8') {
        return '出票失败'
      } else if (this.Paystatus == '9') {
        return '影院退票'
      } else if (this.Paystatus == '10') {
        return '待收货'
      } else if (this.Paystatus == '15') {
        return '已关闭'
      } else if (this.Paystatus == '25') {
        return '已退款'
      }
    },
    getStatusClass() {
      const status = this.Paystatus
      if (status == '0') return 'status-payment'
      return 'status-other'
    },
    copyText(text) {
      // 统一复制功能实现
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$Toast('复制成功');
        }).catch(() => {
          this.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },
    fallbackCopy(text) {
      // 兼容性复制方法
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.$Toast('复制成功');
      } catch (err) {
        this.$Toast('复制失败');
      }
      document.body.removeChild(textArea);
    },
  },
  mounted() {
    // console.log(this.list);
    this.Paystatus = this.$route.query.status
    this.orderNo = this.$route.query.orderNo

    this.userId = JSON.parse(localStorage.getItem("userInfo")).id
    this.phone = localStorage.getItem("loginphone")
    this.queryMovieTicketDetail().finally(() => {
      this.startUnifiedCashierPayPollIfNeeded();
    });
    if (this.$route.query.fromUnifiedCashier === '1') {
      this.enableBrowserBackGuard()
    }
    // 进入页面自动滚动到顶部
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    this.stopUnifiedCashierPayPoll();
    this.disableBrowserBackGuard()
    if (this.cooldownTimer) {
      clearInterval(this.cooldownTimer)
      this.cooldownTimer = null
    }
  },
  computed: {
    cooldownText() {
      if (this.isCooldown && this.cooldownRemain > 0) {
        return this.cooldownRemain + 's 后可刷新'
      }
      return '点击刷新'
    }
  },
  watch: {},
};
</script>

<style lang='scss' scoped>
@import "@/styles/order-card.scss";

.cooldown-text { display: inline; }
.box {
  background-color: #f8f8f8;
  min-height: 100vh;
  overflow-x: hidden;
}

.content-container {
  min-height: calc(100vh - 3rem);
  overflow-y: auto;
  padding-top: var(--order-page-top-gap, 0.4rem);
  padding-bottom: 3rem;

  .img {
    width: 5.6rem;
    height: 7.5rem;
    border-radius: 0.5rem;
  }

  .msg {
    margin-top: 20px;
    padding-top: 5px;
    border-top: 1px solid #ededed;
  }
}

.tickets {
  width: 8rem;
  height: 8rem;
  margin-top: 1rem;
}

.price {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  color: #D23B2E;
  font-size: 1.1rem;
  min-width: 0;
  overflow: hidden;
}

.bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  border-top: 1px solid #ededed;
  padding: 0.6rem 1rem;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 10;
  overflow: hidden;
  box-sizing: border-box;
}

.order-status-tag {
    transition: all 0.3s ease;
}

/* 待支付 - 红色渐变 */
.order-status-tag.status-payment {
    background: linear-gradient(135deg, #FF6B6B 0%, #D23B2E 100%);
    color: white;
    box-shadow: 0 4px 12px rgba(210, 59, 46, 0.3);
}

/* 其他状态 - 蓝色渐变 */
.order-status-tag.status-other {
    background: linear-gradient(135deg, #4DABF7 0%, #1890FF 100%);
    color: white;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}
.refresh-btn {
  position: absolute;
  top: -0.5rem;
  right: 1rem;
  display: inline-block;
  font-size: 0.75rem;
  color: #1890FF;
  background: #f5f7fa;
  border: 1px solid #e0e0e0;
  padding: 0.3rem 0.6rem;
  border-radius: 0.8rem;
  z-index: 10;
}
.refresh-btn:active {
  background: #eef2f6;
  transform: scale(0.98);
}
.refresh-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.6rem;
}
.refresh-tip {
  font-size: 0.8rem;
  color: #888;
  margin-bottom: 0.8rem;
  text-align: center;
}
.refresh-btn-wrapper {
  width: 100%;
  padding: 0 1rem;
}
.refresh-btn-large {
  width: 100%;
  height: 2.6rem;
  border: 1px solid #ff6b81;
  border-radius: 1.3rem;
  background: #ffffff;
  color: #ff6b81;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(255, 107, 129, 0.1);
}
.refresh-btn-large:active:not(.disabled) {
  background: #fff5f7;
  transform: scale(0.98);
  box-shadow: 0 1px 4px rgba(255, 107, 129, 0.15);
}
.refresh-btn-large.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.info-block + .info-block {
  margin-top: 0.6rem;
  padding-top: 0.6rem;
  border-top: 1px solid #f0f0f0;
}


.cinema-title, .order-title, .ticket-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.3rem;
}
.cinema-address, .movie-hall, .movie-time, .movie-seat, .ticket-num {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.2rem;
}

/* 电影信息区域 - 与 ConfigOrder 统一样式 */
.movie-info-row {
  display: flex;
  gap: 0.8rem;
}

.movie-poster {
  width: 5.5rem;
  height: 7.5rem;
  border-radius: 0.5rem;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.movie-details {
  flex: 1;
  min-width: 0;
}

.movie-name {
  font-size: 1.15rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.4rem;
  line-height: 1.3;
}

.movie-time-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.4rem;
}

.play-time {
  font-size: 0.95rem;
  font-weight: 600;
  color: #ee0a24;
}

.hall-type-tag {
  display: inline-block;
  padding: 0.1rem 0.4rem;
  background: linear-gradient(135deg, #ff6b4a 0%, #ee0a24 100%);
  color: #fff;
  font-size: 0.7rem;
  border-radius: 0.2rem;
  font-weight: 500;
}

/* 影院信息区域 - 与影院列表样式一致 */
.cinema-info-block {
  margin-bottom: 0.6rem;
}

.cinema-name-main {
  font-size: 1.05rem;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  margin-bottom: 0.4rem;
  word-break: break-word;
}

.cinema-addr-row {
  display: flex;
  align-items: flex-start;
  gap: 0.3rem;
  font-size: 0.85rem;
  color: #999;
  line-height: 1.5;
  
  span {
    word-break: break-word;
  }
  
  .van-icon {
    flex-shrink: 0;
    margin-top: 0.15rem;
  }
}

.cinema-name-row {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.2rem;
}

.hall-name {
  font-size: 0.85rem;
  color: #999;
}

/* 座位信息高亮框 */
.seat-info-box {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.8rem;
  padding: 0.6rem 0.8rem;
  background: linear-gradient(135deg, #fff5f5 0%, #fff0ed 100%);
  border-radius: 0.4rem;
  border: 1px solid #ffebe8;
}

.seat-value {
  font-size: 0.9rem;
  font-weight: 600;
  color: #ee0a24;
}

/* 行内座位信息样式 */
.seat-info-inline {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  margin-top: 0.5rem;
  padding: 0.4rem 0.6rem;
  background: linear-gradient(135deg, #fff5f5 0%, #fff0ed 100%);
  border-radius: 0.3rem;
  border: 1px solid #ffebe8;
  
  .seat-value {
    font-size: 0.8rem;
    font-weight: 600;
    color: #ee0a24;
  }
}

.img {
  width: 5.6rem;
  height: 7.5rem;
  border-radius: 0.8rem;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-right: 1rem;
}
.movie-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.movie-title {
  font-weight: 600;
  font-size: 0.9rem;
  color: #333;
  margin-bottom: 0.2rem;
}
.ticket-swipe-wrapper {
  padding: 1.2rem !important;
  background: white;
  
  .ticket-title-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    
    .ticket-title {
      font-size: 1rem;
      font-weight: 600;
      color: #333;
    }
    
    .ticket-count-badge {
      font-size: 0.75rem;
      background: #f0f7ff;
      color: #1890FF;
      padding: 0.2rem 0.6rem;
      border-radius: 1rem;
      font-weight: 500;
    }
  }
}

.ticket-swipe {
  padding-bottom: 1.5rem; // 为指示器留位
  
  .ticket-slide-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .qr-section {
      background: #fff;
      padding: 0.5rem;
      border: 1px solid #f0f0f0;
      border-radius: 0.8rem;
      box-shadow: 0 4px 12px rgba(0,0,0,0.03);
      margin-bottom: 1.2rem;
      
      .qr-image {
        width: 10rem;
        height: 10rem;
        display: block;
      }
    }
    
    .code-section {
      width: 100%;
      background: #f9f9f9;
      border-radius: 0.6rem;
      padding: 0.4rem 1.2rem; // 减小容器 padding，靠 row 的 padding 来撑起高度
      
      .code-row {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.8rem 0; 
        line-height: 1; // 强制行高为1，避免字体内部边距干扰垂直对齐
        
        &:not(:last-child) {
          border-bottom: 1px dashed #e8e8e8;
        }
        
        .code-label {
          font-size: 0.9rem;
          color: #888;
          margin-right: 0.4rem;
          display: flex;
          align-items: center;
        }
        
        .code-value {
          font-size: 1.1rem;
          font-weight: 700;
          color: #333;
          letter-spacing: 0.5px;
          font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
          display: flex;
          align-items: center;
        }
      }
    }
    
    .machine-info {
      margin-top: 0.8rem;
      font-size: 0.75rem;
      color: #999;
      display: flex;
      align-items: center;
      gap: 0.2rem;
    }
  }
}

.order-number-section {
  display: flex;
  align-items: center;
}

/* ========== 统一复制按钮样式 ========== */
.copy-btn {
  margin-left: 0.5rem;
  padding: 0.1rem 0.4rem;
  background: rgba(102, 102, 102, 0.1);
  color: #666;
  font-size: 0.75rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(102, 102, 102, 0.3);
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  display: inline-block;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.copy-btn:active {
  background: rgba(102, 102, 102, 0.2) !important;
  transform: scale(0.95) !important;
}
/* ========== 复制按钮样式结束 ========== */

/* ========== 统一操作按钮样式 ========== */
.action-btn {
  display: inline-block;
  padding: 0;
  border-radius: 1rem;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  height: 1.8rem;
  line-height: 1.8rem;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  border-width: 0.5px;
  border-style: solid;
  flex-shrink: 0;
  min-width: 4rem;
  max-width: calc(45% - 0.3rem);
  vertical-align: middle;
  text-align: center;
}

.action-btn + .action-btn {
  margin-left: 0.5rem;
}

.bottom .flex {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 0.5rem;
}

.action-btn-primary {
  background-image: linear-gradient(left, #ffcf7a 0%, #ffa976 100%);
  color: #f5f5f5;
  border-color: rgba(255, 207, 122, 0.3);
}

.action-btn-primary:active {
  background-image: linear-gradient(left, #f5c470 0%, #f59e6c 100%);
  transform: scale(0.98) !important;
}

.action-btn-secondary {
  background: rgba(102, 102, 102, 0.05);
  color: #666666;
  border-color: rgba(102, 102, 102, 0.3);
}

.action-btn-secondary:active {
  background: rgba(102, 102, 102, 0.12) !important;
  transform: scale(0.98) !important;
}
/* ========== 操作按钮样式结束 ========== */

.movie-time-highlight {
  background: linear-gradient(90deg, #FFE5E0 0%, #FFF9F8 100%);
  color: #D23B2E;
  font-weight: 600;  
  font-size: 0.85rem;
  padding: 0.4rem 0.8rem;
  border-radius: 0.8rem;
  margin: 0.2rem 0;
  border: 1px solid #FFD6D0;
  display: inline-block;
  text-align: center;
  line-height: 1.2;
  min-width: fit-content;
  width: auto;
}

.movie-seat-highlight {
  background: linear-gradient(90deg, #E8F5FF 0%, #F0F9FF 100%);
  color: #1890FF;
  font-weight: 600;
  font-size: 0.85rem;
  padding: 0.4rem 0.8rem;
  border-radius: 0.8rem;
  margin: 0.2rem 0;
  border: 1px solid #B3D8FF;
  display: inline-block;
  text-align: center;
  line-height: 1.2;
  min-width: fit-content;
  width: auto;
}

/* 展开行样式 */
.expandable-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0.3rem 0.5rem;
  margin: 0 -0.5rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.expandable-row:hover {
  background-color: #f8f9fa;
}

.expandable-row:active {
  background-color: #e9ecef;
  transform: scale(0.98);
}

.row-label {
  margin: 0.5rem;
  color: #888;
}

.row-value {
  color: #333;
  margin-right: 0.3rem;
}

.expand-indicator {
  display: flex;
  align-items: center;
  margin: 0.5rem;
}

.expand-text {
  font-size: 0.8rem;
  color: #1890FF;
  font-weight: 500;
  margin-right: 0.3rem;
}

.ticket-pending {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 1.2rem;
  text-align: center;
  
  .tickets {
    width: 8rem;
    height: 8rem;
  }
  
  .pending-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin-top: 1rem;
  }
  
  .pending-desc {
    font-size: 0.95rem;
    color: #666;
    margin: 0.8rem 1.5rem;
    line-height: 1.5;
  }
}
</style>